import * as React from 'react';

import './Checkout.page.scss';
import { CheckoutDispatcher } from 'src/app/Container/Dispatcher/CartDispatcher';
import { 
  TroughPartialCheckoutComponent, 
  TotalPriceCheckoutComponent, 
  WashbasinDimensionsPartialCheckoutComponent, 
  ApronBacksplashPartialCheckoutComponent,
  ReccessesPartialCheckoutComponent,
  ColourPartialCheckoutComponent,
  AssemblyAccessoriesPartialCheckoutComponent,
  LogoCentered,
} from 'src/app/Partials';
import { ConfigurationDispatcher } from 'src/app/Container';
import { GlobalPrivateState } from 'src/api';
import { ConfigurationModel } from 'franke-trough-dependencies';
import { connect } from 'react-redux';

import { Link} from 'react-router-dom';
import { FormattedNumber } from 'react-intl';
import PartList from 'src/app/Partials/Configuration/Checkout/Parts/PartList';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './Checkout.messages';

export interface CheckoutPageProps {
  configurationId: string;
  dispatch: any;
  configuration: GlobalPrivateState['configuration'];
  checkout: GlobalPrivateState['checkout'];
}

export class CheckoutPage extends React.Component<CheckoutPageProps, any> {
  public render() {
    const checkout = this.props.checkout.result;
    return (
      <div className="checkout-page pt-5">
        {this.props.configurationId && (
          <> 
            {this.configuration && (
              <CheckoutDispatcher configurationId={this.props.configurationId} />
            )}
            <ConfigurationDispatcher id={this.props.configurationId} />
          </>
        )}
        <div className="container">
          <div className="row">
            <div className="col-12 sticky-header pl-5 pt-5 pr-5 pb-5">
              <LogoCentered />
              <h2>
              {this.configuration && (
                <>
                <FormattedMessage {...MESSAGES.checkoutHeadline} /> {this.configuration.name}
                </>
              )}
              </h2>
              <div className="back-button">
                <Link to={`trough`} className="btn btn-secondary text-white"><FormattedMessage {...MESSAGES.checkoutBackButton} /></Link>
              </div>
            </div>
            
            {checkout && checkout.totals && (
              <div className="product-list-wrap">
                <div className="row">
                  <div className="col-12 col-md-8">
                    <div className="row">
                        <div className="col-12">
                          <h4 className="border-bottom">
                            <FormattedMessage {...MESSAGES.checkoutConfigurationHeadline} />&nbsp;
                            <span className="price">
                              <FormattedNumber 
                                value={checkout.subTotals.configuration.net} 
                                currency={checkout.currency}
                                currencyDisplay="code"
                                style="currency" 
                                minimumFractionDigits={0}
                              />
                            </span>
                          </h4>
                        </div>
                      <div className="col-12">
                        <div className="selected-products">
                          <ul>
                            {/* <li><GeneralInformationCheckoutComponent /></li> */}
                            <li><TroughPartialCheckoutComponent /></li>
                            <li><WashbasinDimensionsPartialCheckoutComponent /></li>
                            <li><ApronBacksplashPartialCheckoutComponent /></li>
                            <li><ReccessesPartialCheckoutComponent /></li>
                            <li><ColourPartialCheckoutComponent /></li>
                            <li><AssemblyAccessoriesPartialCheckoutComponent /></li>
                          </ul>
                        </div>
                      </div>
                      {this.props.checkout.result && this.props.checkout.result.lines.parts && (
                        <>
                        <div className="col-12">
                          <h4 className="border-bottom">
                            <FormattedMessage {...MESSAGES.checkoutPartsHeadline} />&nbsp;
                            <span className="price">
                              <FormattedNumber 
                                  value={checkout.subTotals.parts.base} 
                                  currency={checkout.currency}
                                currencyDisplay="code"
                                style="currency" 
                              />
                            </span>
                          </h4>
                        </div>
                        <div className="col-12">
                          <PartList />
                        </div>
                        </>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-4">
                    <TotalPriceCheckoutComponent />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  private get configuration(): ConfigurationModel | undefined {
    const { configuration } = this.props;
    return configuration && configuration.result;
  }
}

export const CheckoutPageComponent = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration,
  checkout: state.checkout,
}))(CheckoutPage);

export default CheckoutPageComponent;